// import React, { useState, useEffect } from "react";
// import "./MediaGallery.css";

// const MediaGallery = () => {
//   const [photoEvents, setPhotoEvents] = useState([]);
//   const [selectedEvent, setSelectedEvent] = useState("Alumni Speaks 01");
//   const [selectedImage, setSelectedImage] = useState(null);

//   useEffect(() => {
//     fetch("/media.json")
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.photoEvents) {
//           setPhotoEvents(data.photoEvents);
//         } else {
//           console.error("Invalid JSON structure");
//         }
//       })
//       .catch((error) => console.error("Error loading media:", error));
//   }, []);

//   const handleEventSelection = (eventName) => {
//     setSelectedEvent(eventName);
//   };

//   const filteredImages =
//     photoEvents.find((event) => event.eventName === selectedEvent)?.photos || [];

//   // Extract speakers safely
//   const selectedEventData = photoEvents.find((event) => event.eventName === selectedEvent);

//   const speakers = selectedEventData
//     ? [selectedEventData.speaker1, selectedEventData.speaker2].filter((speaker) => speaker && speaker.trim() !== "")
//     : [];

//   return (
//     <div className="media-page">
//       <h1>Media Gallery</h1>

//       {/* Event Selection Buttons */}
//       <div className="event-buttons">
//         {["Alumni Speaks 01", "Alumni Speaks 02", "Alumni Speaks 03", "Alumni Speaks 04"].map((eventName, index) => (
//           <button
//             key={index}
//             className={selectedEvent === eventName ? "active" : ""}
//             onClick={() => handleEventSelection(eventName)}
//           >
//             {eventName}
//           </button>
//         ))}
//       </div>

//       {/* Speaker Names Display */}
//       {speakers.length > 0 && (
//         <div className="speakers-container">
//           <strong>Speakers : </strong> {speakers.join(" , ")}
//         </div>
//       )}

//       {/* Grid Layout for Images */}
//       <div className="media-grid">
//         {filteredImages.map((image, index) => (
//           <div key={index} className="media-item" onClick={() => setSelectedImage(image)}>
//             <img 
//               src={image} 
//               alt={`Event ${selectedEvent} - ${index}`}
//               loading="lazy"  // Added lazy loading
//             />
//           </div>
//         ))}
//       </div>

//       {/* Fullscreen Image View */}
//       {selectedImage && (
//         <div className="overlay" onClick={() => setSelectedImage(null)}>
//           <div className="fullscreen-container">
//             <img src={selectedImage} alt="Fullscreen" />
//             <button className="close-btn" onClick={() => setSelectedImage(null)}>&times;</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MediaGallery;

// // import React, { useState, useEffect } from "react";
// // import "./MediaGallery.css";

// // const MediaGallery = () => {
// //   const [photoEvents, setPhotoEvents] = useState([]);
// //   const [selectedEvent, setSelectedEvent] = useState("Alumni Speaks 01");
// //   const [selectedImage, setSelectedImage] = useState(null);
// //   const [imageOrientations, setImageOrientations] = useState({});

// //   useEffect(() => {
// //     fetch("/media.json")
// //       .then((response) => response.json())
// //       .then((data) => {
// //         if (data.photoEvents) {
// //           setPhotoEvents(data.photoEvents);
// //         }
// //       })
// //       .catch((error) => console.error("Error loading media:", error));
// //   }, []);

// //   // Preload images to check orientation
// //   useEffect(() => {
// //     const currentEvent = photoEvents.find((event) => event.eventName === selectedEvent);
// //     if (!currentEvent) return;

// //     const newOrientations = {};
// //     currentEvent.photos.forEach((src) => {
// //       const img = new Image();
// //       img.onload = () => {
// //         newOrientations[src] = img.naturalHeight > img.naturalWidth ? "portrait" : "landscape";
// //         // Once all images are checked, update state
// //         if (Object.keys(newOrientations).length === currentEvent.photos.length) {
// //           setImageOrientations({ ...imageOrientations, ...newOrientations });
// //         }
// //       };
// //       img.src = src;
// //     });
// //   }, [selectedEvent, photoEvents]);

// //   const handleEventSelection = (eventName) => {
// //     setSelectedEvent(eventName);
// //   };

// //   const selectedEventData = photoEvents.find((event) => event.eventName === selectedEvent);
// //   const filteredImages = selectedEventData?.photos || [];

// //   const speakers = selectedEventData
// //     ? [selectedEventData.speaker1, selectedEventData.speaker2].filter(Boolean)
// //     : [];

// //   return (
// //     <div className="media-page">
// //       <h1>Media Gallery</h1>

// //       {/* Event Selection Buttons */}
// //       <div className="event-buttons">
// //         {photoEvents.map((event, idx) => (
// //           <button
// //             key={idx}
// //             className={selectedEvent === event.eventName ? "active" : ""}
// //             onClick={() => handleEventSelection(event.eventName)}
// //           >
// //             {event.eventName}
// //           </button>
// //         ))}
// //       </div>

// //       {/* Speaker Names */}
// //       {speakers.length > 0 && (
// //         <div className="speakers-container">
// //           {speakers.join(" & ")}
// //         </div>
// //       )}

// //       {/* Media Grid */}
// //       <div className="media-grid">
// //         {filteredImages.map((src, idx) => (
// //           <div key={idx} className="media-item" onClick={() => setSelectedImage(src)}>
// //             <img
// //               src={src}
// //               loading="lazy"
// //               className={imageOrientations[src] === "portrait" ? "portrait-image" : ""}
// //               alt={`Event Image ${idx + 1}`}
// //             />
// //           </div>
// //         ))}
// //       </div>

// //       {/* Fullscreen View */}
// //       {selectedImage && (
// //         <div className="overlay" onClick={() => setSelectedImage(null)}>
// //           <div className="fullscreen-container" onClick={(e) => e.stopPropagation()}>
// //             <img src={selectedImage} alt="Fullscreen view" />
// //             <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default MediaGallery;


// -------------------------Earlier complete code without portrait/landscape check-------------------------







// ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// -----------Completely new code taken from Ayush's Desktop which incorporates the mapping of the events to the media pagedirectly. Edited from the latest code zip sent on 12th apr updated one. 

// import React, { useState, useEffect, useRef } from "react";
// import "./MediaGallery.css";
// import { useLocation } from 'react-router-dom';

// const MediaGallery = () => {
//   const location = useLocation();
//   const [photoEvents, setPhotoEvents] = useState([]);
//   const [selectedEvent, setSelectedEvent] = useState("Alumni Speaks 01");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const eventButtonsRef = useRef(null);

//   useEffect(() => {
//     // Set initial event from location state if available
//     if (location.state?.selectedEvent) {
//       setSelectedEvent(location.state.selectedEvent);
//     }

//     // Fetch media data
//     fetch("/media.json")
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.photoEvents) {
//           setPhotoEvents(data.photoEvents);
//         } else {
//           console.error("Invalid JSON structure");
//         }
//       })
//       .catch((error) => console.error("Error loading media:", error));
//   }, [location.state]);

//   useEffect(() => {
//     // Scroll to event buttons when event is selected via navigation
//     if (location.state?.selectedEvent && eventButtonsRef.current) {
//       eventButtonsRef.current.scrollIntoView({ 
//         behavior: 'smooth',
//         block: 'start'
//       });
//     }
//   }, [location.state, photoEvents]);

//   const handleEventSelection = (eventName) => {
//     setSelectedEvent(eventName);
//   };

//   const filteredImages =
//     photoEvents.find((event) => event.eventName === selectedEvent)?.photos || [];

//   const selectedEventData = photoEvents.find((event) => event.eventName === selectedEvent);

//   const speakers = selectedEventData
//     ? [selectedEventData.speaker1, selectedEventData.speaker2].filter((speaker) => speaker && speaker.trim() !== "")
//     : [];

//   return (
//     <div className="media-page">
//       <h1>Media Gallery</h1>

//       <div className="event-buttons" ref={eventButtonsRef}>
//         {["Alumni Speaks 01", "Alumni Speaks 02", "Alumni Speaks 03", "Alumni Speaks 04"].map((eventName, index) => (
//           <button
//             key={index}
//             className={selectedEvent === eventName ? "active" : ""}
//             onClick={() => handleEventSelection(eventName)}
//           >
//             {eventName}
//           </button>
//         ))}
//       </div>

//       {speakers.length > 0 && (
//         <div className="speakers-container">
//           <strong>Speakers : </strong> {speakers.join(" , ")}
//         </div>
//       )}

//       <div className="media-grid">
//         {filteredImages.map((image, index) => (
//           <div key={index} className="media-item" onClick={() => setSelectedImage(image)}>
//             <img 
//               src={image} 
//               alt={`Event ${selectedEvent} - ${index}`}
//               loading="lazy"
//             />
//           </div>
//         ))}
//       </div>

//       {selectedImage && (
//         <div className="overlay" onClick={() => setSelectedImage(null)}>
//           <div className="fullscreen-container">
//             <img src={selectedImage} alt="Fullscreen" />
//             <button className="close-btn" onClick={() => setSelectedImage(null)}>&times;</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MediaGallery;

// code for media without the portrait and landscape check
// ---------------------------------------------------------------------------------------------------------------------------------



// code with portrait and landscape check
// import React, { useState, useEffect } from "react";
// import "./MediaGallery.css";

// const MediaGallery = () => {
//   const [photoEvents, setPhotoEvents] = useState([]);
//   const [selectedEvent, setSelectedEvent] = useState("Alumni Speaks 01");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageOrientations, setImageOrientations] = useState({});

//   useEffect(() => {
//     fetch("/media.json")
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.photoEvents) {
//           setPhotoEvents(data.photoEvents);
//         }
//       })
//       .catch((error) => console.error("Error loading media:", error));
//   }, []);

//   // Preload images to check orientation
//   useEffect(() => {
//     const currentEvent = photoEvents.find((event) => event.eventName === selectedEvent);
//     if (!currentEvent) return;

//     const newOrientations = {};
//     currentEvent.photos.forEach((src) => {
//       const img = new Image();
//       img.onload = () => {
//         newOrientations[src] = img.naturalHeight > img.naturalWidth ? "portrait" : "landscape";
//         // Once all images are checked, update state
//         if (Object.keys(newOrientations).length === currentEvent.photos.length) {
//           setImageOrientations({ ...imageOrientations, ...newOrientations });
//         }
//       };
//       img.src = src;
//     });
//   }, [selectedEvent, photoEvents]);

//   const handleEventSelection = (eventName) => {
//     setSelectedEvent(eventName);
//   };

//   const selectedEventData = photoEvents.find((event) => event.eventName === selectedEvent);
//   const filteredImages = selectedEventData?.photos || [];

//   const speakers = selectedEventData
//     ? [selectedEventData.speaker1, selectedEventData.speaker2].filter(Boolean)
//     : [];

//   return (
//     <div className="media-page">
//       <h1>Media Gallery</h1>

//       {/* Event Selection Buttons */}
//       <div className="event-buttons">
//         {photoEvents.map((event, idx) => (
//           <button
//             key={idx}
//             className={selectedEvent === event.eventName ? "active" : ""}
//             onClick={() => handleEventSelection(event.eventName)}
//           >
//             {event.eventName}
//           </button>
//         ))}
//       </div>

//       {/* Speaker Names */}
//       {speakers.length > 0 && (
//         <div className="speakers-container">
//           {speakers.join(" & ")}
//         </div>
//       )}

//       {/* Media Grid */}
//       <div className="media-grid">
//         {filteredImages.map((src, idx) => (
//           <div key={idx} className="media-item" onClick={() => setSelectedImage(src)}>
//             <img
//               src={src}
//               loading="lazy"
//               className={imageOrientations[src] === "portrait" ? "portrait-image" : ""}
//               alt={`Event Image ${idx + 1}`}
//             />
//           </div>
//         ))}
//       </div>

//       {/* Fullscreen View */}
//       {selectedImage && (
//         <div className="overlay" onClick={() => setSelectedImage(null)}>
//           <div className="fullscreen-container" onClick={(e) => e.stopPropagation()}>
//             <img src={selectedImage} alt="Fullscreen view" />
//             <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MediaGallery;

import React, { useState, useEffect, useRef } from "react";
import "./MediaGallery.css";
import { useLocation, useNavigate } from 'react-router-dom';

const MediaGallery = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [photoEvents, setPhotoEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(
    location.state?.selectedEvent || "Alumni Speaks 01"
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const eventSectionRef = useRef(null);
  const eventButtonsRef = useRef(null); // Added missing ref

  // Verify correct route on mount
  useEffect(() => {
    if (!location.pathname.includes('media-page')) {
      console.warn("Redirecting to correct media page path");
      navigate('/pages/media-page', { 
        replace: true,
        state: location.state 
      });
    }
  }, [location.pathname, navigate, location.state]);

  useEffect(() => {
    const loadMediaData = async () => {
      try {
        const response = await fetch("/media.json");
        const data = await response.json();
        
        if (data.photoEvents) {
          setPhotoEvents(data.photoEvents);
          
          // Validate the passed event exists
          if (location.state?.selectedEvent) {
            const eventExists = data.photoEvents.some(
              e => e.eventName === location.state.selectedEvent
            );
            if (eventExists) {
              setSelectedEvent(location.state.selectedEvent);
            }
          }
        }
      } catch (error) {
        console.error("Error loading media data:", error);
      }
    };

    loadMediaData();
  }, [location.state]);

  // Scroll to section when event is selected
  useEffect(() => {
    if (eventButtonsRef.current) {
      eventButtonsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [selectedEvent]);

  const handleEventSelection = (eventName) => {
    setSelectedEvent(eventName);
  };

  const filteredImages = photoEvents.find(
    event => event.eventName === selectedEvent
  )?.photos || [];

  const selectedEventData = photoEvents.find(
    event => event.eventName === selectedEvent
  );

  const speakers = selectedEventData
    ? [selectedEventData.speaker1, selectedEventData.speaker2]
        .filter(speaker => speaker?.trim())
    : [];

  return (
    <div className="media-page" ref={eventSectionRef}>
      <h1>Media Gallery</h1>

      <div className="event-buttons" ref={eventButtonsRef}>
        {["Alumni Speaks 01", "Alumni Speaks 02", "Alumni Speaks 03", "Alumni Speaks 04"].map((eventName, index) => (
          <button
            key={index}
            className={selectedEvent === eventName ? "active" : ""}
            onClick={() => handleEventSelection(eventName)}
          >
            {eventName}
          </button>
        ))}
      </div>

      {speakers.length > 0 && (
        <div className="speakers-container">
          <strong>Speakers : </strong> {speakers.join(" , ")}
        </div>
      )}

      <div className="media-grid">
        {filteredImages.map((image, index) => (
          <div key={index} className="media-item" onClick={() => setSelectedImage(image)}>
            <img 
              src={image} 
              alt={`Event ${selectedEvent} - ${index}`}
              loading="lazy"
            />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="overlay" onClick={() => setSelectedImage(null)}>
          <div className="fullscreen-container">
            <img src={selectedImage} alt="Fullscreen" />
            <button className="close-btn" onClick={() => setSelectedImage(null)}>&times;</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaGallery;


// ------------------------Updated the MediaGallery.jsx file with different things The first comment is the one which was working initially without the portrait and lanscape check and later these are with the checks
// ------------------------Later This is the one working with the mapping of each event from the homepage with the media section of that particular event and the speakers of that event and the images of that event and the selected image is also working fine with the close button and the overlay and the lazy loading of the images is also done and the scroll to the event buttons is also done and the event buttons are also working fine with the selected event and the selected image is also working fine with the close button and the overlay and the lazy loading of the images is also done and the scroll to the event buttons is also done and the event buttons are also working fine with the selected event and the selected image is also working fine with the close button and the overlay and the lazy loading of the images is also done and the scroll to the event buttons is also done and the event buttons are also working fine with the selected event and the selected image is also working fine with the close button and the overlay and the lazy loading of the images is also done and the scroll to the event buttons is also done

// const location = useLocation();
//   const [photoEvents, setPhotoEvents] = useState([]);
//   const [selectedEvent, setSelectedEvent] = useState("Alumni Speaks 01");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const eventButtonsRef = useRef(null);

//   useEffect(() => {
//     // Set initial event from location state if available
//     if (location.state?.selectedEvent) {
//       setSelectedEvent(location.state.selectedEvent);
//     }

//     // Fetch media data
//     fetch("/media.json")
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.photoEvents) {
//           setPhotoEvents(data.photoEvents);
//         } else {
//           console.error("Invalid JSON structure");
//         }
//       })
//       .catch((error) => console.error("Error loading media:", error));
//   }, [location.state]);

//   useEffect(() => {
//     // Scroll to event buttons when event is selected via navigation
//     if (location.state?.selectedEvent && eventButtonsRef.current) {
//       eventButtonsRef.current.scrollIntoView({ 
//         behavior: 'smooth',
//         block: 'start'
//       });
//     }
//   }, [location.state, photoEvents]);

//   const handleEventSelection = (eventName) => {
//     setSelectedEvent(eventName);
//   };

//   const filteredImages =
//     photoEvents.find((event) => event.eventName === selectedEvent)?.photos || [];

//   const selectedEventData = photoEvents.find((event) => event.eventName === selectedEvent);

//   const speakers = selectedEventData
//     ? [selectedEventData.speaker1, selectedEventData.speaker2].filter((speaker) => speaker && speaker.trim() !== "")
//     : [];

//   return (
//     <div className="media-page">
//       <h1>Media Gallery</h1>

//       <div className="event-buttons" ref={eventButtonsRef}>
//         {["Alumni Speaks 01", "Alumni Speaks 02", "Alumni Speaks 03", "Alumni Speaks 04"].map((eventName, index) => (
//           <button
//             key={index}
//             className={selectedEvent === eventName ? "active" : ""}
//             onClick={() => handleEventSelection(eventName)}
//           >
//             {eventName}
//           </button>
//         ))}
//       </div>

//       {speakers.length > 0 && (
//         <div className="speakers-container">
//           <strong>Speakers : </strong> {speakers.join(" , ")}
//         </div>
//       )}

//       <div className="media-grid">
//         {filteredImages.map((image, index) => (
//           <div key={index} className="media-item" onClick={() => setSelectedImage(image)}>
//             <img 
//               src={image} 
//               alt={`Event ${selectedEvent} - ${index}`}
//               loading="lazy"
//             />
//           </div>
//         ))}
//       </div>

//       {selectedImage && (
//         <div className="overlay" onClick={() => setSelectedImage(null)}>
//           <div className="fullscreen-container">
//             <img src={selectedImage} alt="Fullscreen" />
//             <button className="close-btn" onClick={() => setSelectedImage(null)}>&times;</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );